import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Select, MenuItem } from "@mui/material";

export default function Nav() {
  const navItem = [
    {
      label: "Table Linen & Overlays",
      link: "table-linen-overlays",
    },
    {
      label: "Table Runners",
      link: "table-runner",
    },
    {
      label: "Napkins",
      link: "napkins",
    },
    {
      label: "Chargers & Placemats",
      link: "chargers-placemats",
    },
    {
      label: "Chair Accents",
      link: "chair-accents",
    },
    {
      label: "Spandex Products",
      link: "spandex-products",
    },
    {
      label: "Accessories",
      link: "accessories",
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize(); // Set initial isMobile state
    window.addEventListener("resize", handleResize); // Listen for resize events

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  return (
    <>
      {isMobile ? (
        
          <Select
            value={selectedCategory}
            onChange={handleCategoryChange}
            displayEmpty
            inputProps={{ "aria-label": "Select Category" }}
          >
            <MenuItem value="" disabled>
              Select Category
            </MenuItem>
            {navItem.map((item, index) => (
              <MenuItem key={index} value={item.link}>
                <Link
                  className="nav-item"
                  style={{ cursor: "pointer" }}
                  to={`/?key=${item.link}`}
                >
                  {item.label}
                </Link>
              </MenuItem>
            ))}
          </Select>
      ) : (
        <>
          <ul
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {navItem.map((item, index) => (
              <li
                key={index}
                style={{
                  marginRight: 2,
                  flexBasis: "20%",
                  listStyle: "none",
                  textAlign: "center",
                }}
              >
                <Link
                  className="nav-item"
                  style={{ cursor: "pointer" }}
                  to={`/?key=${item.link}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </>
  );
}
